export default {
  emisorRut: {
    nombre: 'RUT Emisor',
    tipo: 'rut'
  },
  fechaEmision: {
    nombre: 'Fecha de Documento',
    tipo: 'fecha'
  },
  fechaCreacion: {
    nombre: 'Fecha de Creación',
    tipo: 'fecha'
  },
  numero: {
    nombre: 'Folio Expediente',
    tipo: 'numero'
  },
  estado: {
    nombre: 'Estado',
    tipo: 'multi'
  },
  participante: {
    nombre: 'Participante',
    tipo: 'usuarioIds'
  },
  tipo: {
    nombre: 'Tipo de expedientes',
    tipo: 'multi'
  },
  referenciaTipo: {
    nombre: 'Tipo de referencia', // tipo de referencia
    tipo: 'referenciaTipo'
  },
  solicitanteEmail: {
    nombre: 'Usuario que envió a flujo',
    tipo: 'correo'
  }
};
